import { Box, Flex, Typography } from '@fullstory/components';
import { fullstorySelectors } from '@fullstory/redux';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useOrgHistory } from '../../hooks';
import { PlayButton } from '../PlayButton';
import { SessionListItemButton } from '../SessionListItemButton';
import { ServerEventClipListItem } from './ServerEventClipListItem';

interface ClipListItemProps extends Omit<React.ComponentProps<typeof PlayButton>, 'isClip'> {
  title: string;
  numClips: number;
  to: string;
  isWatched: boolean;
  isOnline: boolean;
  onPlayClick: () => void;
  serverEventVars?: string;
  serverEventName?: string;
  serverIntegrationName?: string;
  lastWhen: Date | null;
}

export const ClipListItem: React.FunctionComponent<ClipListItemProps> = ({
  title,
  to,
  numClips,
  isWatched,
  isOnline,
  onPlayClick,
  serverEventName,
  serverEventVars,
  serverIntegrationName,
  lastWhen,
}) => {
  const orgId = useSelector(fullstorySelectors.getOrgId);
  const { orgHistory, retentionTimestamp } = useOrgHistory();
  const insideRetentionWindow =
    !orgHistory || !lastWhen || lastWhen >= new Date(retentionTimestamp);

  return (
    <Box data-component="ClipListItem" width="100%" height={48} style={{ position: 'relative' }}>
      {!to ? (
        <ServerEventClipListItem
          serverEventName={serverEventName}
          serverEventVars={serverEventVars}
          serverIntegrationName={serverIntegrationName}
          title={title}
        />
      ) : (
        <Box padding={[12, 16, 12, 16]}>
          <Flex justifyContent="space-between">
            <Flex alignItems="center" style={{ gap: 5 }}>
              <Box paddingRight={8}>
                <SessionListItemButton
                  insideRetentionWindow={insideRetentionWindow}
                  retentionWindowInMonths={orgHistory}
                  orgId={orgId}
                >
                  <PlayButton
                    isOnline={isOnline}
                    isClip
                    isWatched={isWatched}
                    to={to}
                    onClick={onPlayClick}
                    disabled={!insideRetentionWindow}
                  />
                </SessionListItemButton>
              </Box>
              <Link to={to}>
                <Typography ellipsize variant="body3" color="blue">
                  {title}
                </Typography>
              </Link>
            </Flex>
            <Flex alignItems="flex-end">
              <Typography ellipsize variant="body3" color="neutrals-n12">
                {numClips}
              </Typography>
            </Flex>
          </Flex>
        </Box>
      )}
    </Box>
  );
};
